module.exports = __webpack_public_path__ + "img/SALE.37b837c8.svg";